import React, { memo } from 'react'
import TrackingFilledRedIcon from 'transfix-icons/build/TrackingFilledRedIcon'
import { createStyles, createTheme, makeStyles } from 'transfix-ui/core/styles'
import { rogersFontFamily } from 'transfix-ui/theme'
import { brandColors } from 'transfix-ui/theme/colors'
import { TRACKING_LABELS } from '../../constants'
import { IActiveShipmentFragment } from '../../graphql/ActiveShipmentFragment'
import { ITrackingType } from '../../types'
import { getTrackingType } from '../../utils'

const useTrackingLabelStyles = makeStyles(() => {
  const theme = createTheme()
  return createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      '&.onTime': {
        color: brandColors.skyBlue6,
      },
      '&.runningLate': {
        color: brandColors.warning1,
      },
      '&.notTracking': {
        color: brandColors.error1,
      },
    },
    text: {
      fontFamily: rogersFontFamily,
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.spacing(1.5),
    },
  })
})

export interface ITrackingLabelProps
  extends Pick<IActiveShipmentFragment, 'etaObject' | 'trackingSummary'> {}

const TrackingLabel = memo<ITrackingLabelProps>(({ etaObject, trackingSummary }) => {
  const classes = useTrackingLabelStyles()
  const trackingType = getTrackingType({ etaObject, trackingSummary })
  const trackingLabel = TRACKING_LABELS[trackingType]
  return (
    <div className={`${classes.root} ${trackingType}`}>
      {trackingType === ITrackingType.notTracking && <TrackingFilledRedIcon size='medium' />}
      <div className={classes.text}>{trackingLabel}</div>
    </div>
  )
})

export default TrackingLabel
